import { useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { ASSETS } from "@/lib/assets";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const location = useLocation();
  const denied = location.state?.denied;
  const error = location.state?.error;

  const signIn = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center bg-charcoal px-4">
      <div className="w-full max-w-md border border-slate/20 bg-surface p-10 crimson-glow text-center">
        <img src={ASSETS.labelLogo} alt="Sorrow & Serenity" className="h-20 w-20 object-contain mx-auto" />
        <h1 className="mt-6 font-display text-3xl text-softwhite">Admin Access</h1>
        <p className="mt-3 text-slate font-body text-sm">
          Sorrow &amp; Serenity Music internal dashboard. Authorized accounts only.
        </p>

        {(denied || error) && (
          <div className="mt-6 flex items-start gap-3 border border-crimson/50 bg-crimson/10 p-4 text-left" data-testid="login-error">
            <ShieldAlert size={18} className="text-crimson-bright shrink-0 mt-0.5" />
            <p className="text-softwhite/90 text-sm">
              {denied
                ? "This Google account is not authorized to view the admin dashboard."
                : "Authentication failed. Please try again."}
            </p>
          </div>
        )}

        <button
          onClick={signIn}
          data-testid="google-signin-btn"
          className="mt-8 w-full inline-flex items-center justify-center gap-3 bg-crimson hover:bg-crimson-bright text-softwhite px-8 py-4 font-label uppercase tracking-[0.15em] text-sm transition-colors duration-300"
        >
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
